import { useEffect } from "react";

interface PageSeoProps {
  title: string;
  description: string;
  canonicalPath?: string;
}

export function usePageSeo({ title, description, canonicalPath }: PageSeoProps) {
  const siteUrl =
    typeof import.meta !== "undefined" && (import.meta as Record<string, unknown>).env
      ? ((import.meta as Record<string, unknown>).env as Record<string, string>).VITE_SITE_URL || "https://mulebuyspreadsheets.makeup"
      : "https://mulebuyspreadsheets.makeup";

  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);

    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", `${siteUrl}${canonicalPath}`);
    }

    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    if (canonicalPath) {
      setMeta("og:url", `${siteUrl}${canonicalPath}`, true);
    }

    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
  }, [title, description, canonicalPath, siteUrl]);
}